import classNames from './GoogleErrorClassesModal.module.scss';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Transition } from 'react-transition-group';
import TheButton from '@/components/TheButton/TheButton';
import AppBackdrop from '@/components/AppBackdrop';
import AppModal from '@/components/AppModal';

interface GoogleErrorClassesModalProps {
  show: boolean;
  classes: any;
  onClose: () => void;
}

const GoogleErrorClassesModal = ({ show, classes, onClose }: GoogleErrorClassesModalProps) => {
  const { t } = useTranslation();
  let errorMessage = '';

  if (classes) {
    const totalCourses = Object.keys(classes.resultByCourse).length;
    const errorCount = Object.values(classes.resultByCourse).filter(
      (course: any) => 'error' in course
    ).length;

    if (errorCount === totalCourses) {
      errorMessage = t('completeImportError');
    } else if (errorCount > 0) {
      errorMessage = t('partialImportError');
    }
  }

  return (
    <Transition
      in={show}
      timeout={400}
      mountOnEnter
      unmountOnExit
      children={state => {
        return (
          <>
            <AppBackdrop className={classnames(classNames.backdrop, `backdrop-${state}`)} />
            <AppModal className={classNames.appModal}>
              <div className={classnames(classNames.modal, `fade-${state}`)}>
                <h2>{t('anErrorOccurred')}</h2>
                <span className={classNames.description}>{errorMessage} </span>
                <TheButton
                  className={classNames.closeBtn}
                  text={t('ok')}
                  shouldRecolor={false}
                  emitOnClick={onClose}
                />
              </div>
            </AppModal>
          </>
        );
      }}
    />
  );
};

export default GoogleErrorClassesModal;
